import { LegalScreen } from '@/components/legal/LegalScreen'

export default function TermsOfServiceRoute() {
  return <LegalScreen slug="terms-of-service" />
}
